import Client from '@/services/api/internal/tools/client';
import { errorHandler } from '@/business/apiTreatment/response/baseAPITreatment';

export function affectTechnician(requestId, body) {
  const url = `${process.env.P2C_BASE_URI}/requests/${requestId}/technician`;
  return Client.put(url, body).catch(errorHandler);
}

export function transmitAffectation(requestId, comment) {
  const url = `${process.env.P2C_BASE_URI}/requests/${requestId}/technician/notify`;
  return Client.post(url, { comment }).catch(errorHandler);
}
